import React, { useState } from "react";

import { Link } from "react-router-dom";
// Bootstrap
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";

// Componentes
import Edit from "../../components/CampaignEdit";
import ModalEdit from "../../components/ModalEdit";

// Icons
import * as AiIcons from "react-icons/ai";

import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { FormatDate } from "../../utils/FormatData";
import { Table } from "../../components/ui/Table";
import { httpClient } from "../../utils/HttpClient";
import { useQuery } from "@tanstack/react-query";
const Camapaigns = () => {
  const Auth = useAuth();
  const user = Auth.getSessionData();
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const columns = [
    {
      accessor: "vc_campaignname",
      Header: "Nombre",
    },
    {
      accessor: "vc_databasename",
      Header: "Grupo de Contactos",
    },
    {
      accessor: "i_records",
      Header: "Contactos",
    },
    {
      accessor: "tst_create",
      Header: "Ult. Mensaje",
      Cell: (rowData) => {
        let create = rowData.row.original.tst_create;
        return <>{FormatDate(create)}</>;
      },
    },
    {
      accessor: "i_programmed",
      Header: "Progr.",
    },
    {
      accessor: "i_process",
      Header: "En Proceso",
    },
    {
      accessor: "i_finished",
      Header: "Enviados",
    },
    {
      accessor: "i_canceled",
      Header: "Canc.",
    },
    {
      accessor: "i_total",
      Header: "Mensajes",
    },
    {
      accessor: "i_canceled1",
      Header: "Estatus",
      Cell: (rowData) => {
        let rowDataItem = rowData.row.original;
        return (
          <>
            {rowDataItem.i_canceled === rowDataItem.i_total ? (
              <Badge bg="dark">Inactivo</Badge>
            ) : (
              ""
            )}
            {rowDataItem.i_programmed > 0 ? (
              <Badge bg="info">Programada</Badge>
            ) : (
              ""
            )}
            {rowDataItem.i_process > 0 ? (
              <Badge bg="warning">En Proceso</Badge>
            ) : (
              ""
            )}
            {rowDataItem.i_finished === rowDataItem.i_total ? (
              <Badge bg="success">Concluida</Badge>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let uiddatabase = rowData.row.original.uid_campaigns;
        return (
          <>
            <Link to={"/Campaign/Details/" + uiddatabase}>
              <AiIcons.AiOutlineSearch
                className="IconTable"
                title="Detalles"
                onClick={""}
              />
            </Link>
          </>
        );
      },
    },
  ];

  const { data: listCampaigns, isPending: isLoading } = useQuery({
    queryKey: ["campaigns"],
    queryFn: async () => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}campaigns/getPartnersCampaigns`,
        {
          partner: user.uid_partner,
          uidUser: user.uid_user,
        },
        user.token,
      );

      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Campañas</h2>
            <h3>Administre los grupos de campañas.</h3>
          </div>
          <div className="ms-auto">
            <Link to="/Campaigns/NewCampaign/multi">
              <Button variant="outline-primary" size="sm">
                <AiIcons.AiOutlinePlus /> Agregar
              </Button>{" "}
            </Link>{" "}
          </div>
        </Stack>

        <div className="bg-white rounded-lg p-4 min-h-50 min-w-full">
          <Table
            columns={columns}
            data={listCampaigns}
            config={{
              search: true,
              pagination: true,
              pageSize: 10,
              perPage: 10,
              sortable: true,
              footer: true,
              iconInfoSize: 30,
              infoSize: "xl",
            }}
            loading={isLoading}
            title="Lista de Campañas"
          />
        </div>
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title="Editando Campaña"
      >
        <Edit />
      </ModalEdit>
    </>
  );
};

export default Camapaigns;
